import React from "react";
import { SvgArrow } from "../componet/Footer/style";

function Icon() {
  return (
    <SvgArrow
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 17 10"
    >
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="2.042"
        d="M1.736 8.903l6.899-6.806 6.712 6.806"
      ></path>
    </SvgArrow>
  );
}

export default Icon;
